import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';

const AddRoomDialogSkeleton = () => (
  <div className="dialog_body" style={{ paddingBottom: '4rem' }}>
    <div className="room_toggle_container">
      <Skeleton variant="rect" width="50%" height="4rem" />
      <Skeleton variant="rect" width="50%" height="4rem" />
    </div>
    <div className="preconfigured_form_container" style={{ marginTop: '2rem' }}>
      <div className="input_group">
        <div style={{ marginBottom: '0.8rem' }}>
          <Skeleton variant="text" width="10rem" />
        </div>
        <Skeleton variant="rect" width="100%" height="4.2rem" />
        <div style={{ marginTop: '0.8rem' }}>
          <Skeleton variant="text" width="22rem" />
        </div>
      </div>
      <div className="input_group" style={{ marginTop: '2.4rem' }}>
        <div style={{ marginBottom: '0.8rem' }}>
          <Skeleton variant="text" width="14rem" />
        </div>
        <Skeleton variant="rect" width="100%" height="4.2rem" />
        <div style={{ marginTop: '0.8rem' }}>
          <Skeleton variant="text" width="24rem" />
        </div>
      </div>
      <div style={{ marginTop: '2.8rem' }}>
        <Skeleton variant="rect" width="100%" height="7rem" />
      </div>
    </div>
  </div>
);

export default AddRoomDialogSkeleton;
